function initAudioPlayers() {
  // Select the audio element
  const audioPlayers = document.querySelectorAll(".tbp-audio-player");

  audioPlayers.forEach((player) => {
    const audioEl = player.querySelector(".tbp-audio__audio");

    // Select the play button
    var playButton = player.querySelector(".tbp-audio-player__button-play");
    var playSVG = playButton.querySelector(".play");
    var pauseSVG = playButton.querySelector(".pause");
    var loadingSVG = playButton.querySelector(".loading");

    // Add event listener to play button
    playButton.addEventListener("click", function () {
      if (audioEl.paused) {
        // Show loading state
        playSVG.style.display = "none";
        pauseSVG.style.display = "none";
        loadingSVG.style.display = "block";
        player.classList.add("tbp-audio-loading");
        
        audioEl.play();
      } else {
        audioEl.pause();
        playSVG.style.display = "block";
        pauseSVG.style.display = "none";
        loadingSVG.style.display = "none";
        player.classList.remove("tbp-audio-playing");
        player.classList.remove("tbp-audio-loading");
      }
    });

    // Select the progress bar
    var progressBar = player.querySelector(".tbp-audio-progress");

    // Select the time elements
    var currentTimeElement = player.querySelector(".currenttime");
    var durationTimeElement = player.querySelector(".duration");

    // Update progress bar and time as player plays
    audioEl.addEventListener("timeupdate", function () {
      var progress = (audioEl.currentTime / audioEl.duration) * 100;
      progressBar.value = progress;

      var minutes = Math.floor(audioEl.currentTime / 60);
      var seconds = Math.floor(audioEl.currentTime % 60);
      currentTimeElement.textContent =
        minutes + ":" + (seconds < 10 ? "0" : "") + seconds;

      var durationMinutes = Math.floor(audioEl.duration / 60);
      var durationSeconds = Math.floor(audioEl.duration % 60);
      durationTimeElement.textContent =
        durationMinutes +
        ":" +
        (durationSeconds < 10 ? "0" : "") +
        durationSeconds;
    });

    // Add event listener to progress bar to listen for clicks
    progressBar.addEventListener("click", function (e) {
      // Calculate new time for player
      var clickPositionInPage = e.pageX;
      var progressBarPosition = this.getBoundingClientRect().left;
      var clickPositionInBar = clickPositionInPage - progressBarPosition;
      var timePerPixel = audioEl.duration / this.offsetWidth;
      var newTime = timePerPixel * clickPositionInBar;
      // Set player current time to new time
      audioEl.currentTime = parseFloat(newTime);
    });

    // Handle loading state when audio is buffering
    audioEl.addEventListener("waiting", function (event) {
      playSVG.style.display = "none";
      pauseSVG.style.display = "none";
      loadingSVG.style.display = "block";
      player.classList.add("tbp-audio-loading");
    });

    // Handle when audio is ready to play
    audioEl.addEventListener("playing", function (event) {
      playSVG.style.display = "none";
      pauseSVG.style.display = "block";
      loadingSVG.style.display = "none";
      player.classList.remove("tbp-audio-loading");
      player.classList.add("tbp-audio-playing");
    });

    audioEl.addEventListener("canplaythrough", function (event) {
      player.classList.remove("tbp-audio-loading");

    });
  });
}

initAudioPlayers();
